<div class="px-3 mt-2 user-input-form">
  <mat-form-field class="full-width" appearance="outline" style="width: 100%; margin-top: 4px;">
    <textarea
      #textareaEl
      class="user-input-form-text-field"
      [placeholder]="placeholderText"
      matInput
      [(ngModel)]="inputValue"
      [name]="inputId || 'inputValueField'"
      [attr.id]="inputId || null"
      (ngModelChange)="onValueChange($event)"
      [rows]="rows"
      [attr.aria-labelledby]="ariaLabelledBy || null"
      [attr.aria-label]="ariaLabelledBy ? null : (ariaLabel || placeholderText)"
      [attr.aria-describedby]="ariaDescribedBy || null"
      [attr.aria-invalid]="ariaInvalid ? 'true' : null"
      [required]="ariaRequired"
    ></textarea>
  </mat-form-field>
</div>
